if (!customElements.get('vip-personalization')) {
  customElements.define(
    'vip-personalization',
    class VipPersonalization extends HTMLElement {
      constructor() {
        super();
        this.recipient = this.querySelector('[data-vip-recipient]');
        this.disclosure = this.querySelector('[data-vip-disclosure]');
        this.recipientError = this.querySelector('[data-vip-recipient-error]');
        this.message = this.querySelector('[data-vip-message]');
        this.counter = this.querySelector('[data-vip-message-count]');
        this.form = document.getElementById(this.dataset.formId);
      }

      connectedCallback() {
        if (this.message && this.counter) {
          this.message.addEventListener('input', () => this.updateCount());
          this.updateCount();
        }
        if (this.dataset.requireRecipient === 'true' && this.form) {
          this.boundSubmit = this.onFormSubmit.bind(this);
          this.form.addEventListener('submit', this.boundSubmit, { capture: true });
          this.recipient.addEventListener('input', () => this.toggleError(false));
        }
      }

      disconnectedCallback() {
        if (this.form && this.boundSubmit) {
          this.form.removeEventListener('submit', this.boundSubmit, { capture: true });
        }
      }

      updateCount() {
        const max = this.message.getAttribute('maxlength') || '';
        this.counter.textContent = `${this.message.value.length}/${max}`;
      }

      toggleError(show) {
        if (!this.recipientError) return;
        this.recipientError.hidden = !show;
        this.recipient.setAttribute('aria-invalid', show ? 'true' : 'false');
      }

      onFormSubmit(event) {
        if (this.recipient.value.trim() !== '') {
          this.toggleError(false);
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.disclosure) this.disclosure.open = true;
        this.toggleError(true);
        this.recipient.focus();
        this.recipient.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  );
}
